import { createCampaign, addRecipientsToCampaign } from "~/react/components/lead-campaigns-manager"
import { ResultType } from "~/react/components/multi_domain_search/result"

export const useCampaignsSave = (results: ResultType[], campaigns: { id: number; name: string }[], setCampaigns: (campaigns: { id: number; name: string }[]) => void) => {
  const handleCampaignsSave = async (name: string, campaignId: number, emailId: number) => {
    const result = results.find((result) => result.id === emailId)
    if (!result) {
      console.error("Result not found for emailId", emailId)
      return
    }

    let campaign: { id: number | null; name: string } | null = null

    // If campaignId is null, create a new campaign. Otherwise, use the existing campaign.
    if (campaignId === null) {
      const createCampaignResponse = await createCampaign(name, "domain_search")

      if (createCampaignResponse.ok) {
        const createCampaignJson = await createCampaignResponse.json()
        setCampaigns((prev) => [
          ...prev,
          { id: createCampaignJson.id, name: createCampaignJson.name },
        ])
        campaign = { id: createCampaignJson.id, name: createCampaignJson.name }
      } else {
        App.displayFlash("error", "Failed to create a new campaign")
        return
      }
    } else {
      campaign = { id: campaignId, name: name }
    }

    // Add the lead to the campaign
    const addRecipientsToCampaignResponse = await addRecipientsToCampaign(
      campaign.id,
      [result.email],
    )
    const addRecipientsToCampaignJson =
      await addRecipientsToCampaignResponse.json()

    if (!addRecipientsToCampaignResponse.ok) {
      App.displayFlash("danger", addRecipientsToCampaignJson.errors[0].details)
    } else if (addRecipientsToCampaignJson.data.recipients_added === 0) {
      const reasonWhyLeadWasntAdded =
        addRecipientsToCampaignJson.data.skipped_recipients[0]["reason"]

      if (
        ["duplicate", "unsubscribed", "bounced", "removed"].includes(
          reasonWhyLeadWasntAdded,
        )
      ) {
        const translation = i18n.t(
          `js.back.lead_campaigns_manager.${reasonWhyLeadWasntAdded}`,
          { lead: result.email, campaign: name },
        )
        App.displayFlash("warning", translation)
      } else {
        App.displayFlash(
          "warning",
          i18n.t("js.back.lead_campaigns_manager.not_added", {
            lead: result.email,
            campaign: name,
          }),
        )
      }
    } else {
      App.displayFlash("success", "Lead added to campaign")
    }
  }

  return handleCampaignsSave
}
